const projects = [
  {
    name: 'Solar System',
    image: 'https://64.media.tumblr.com/01a5d14dc7e57b76d3cb18a4a029f991/106ec815427d573a-05/s2048x3072/032eacb5650affa5f5ec9027b1e555136383c3b9.pnj',
    application: 'https://tainnaps.github.io/solar-system/',
    repository: 'https://github.com/tainnaps/solar-system',
    description: 'Landing page with solar system planets and missions to space.',
    technologies: ['HTML', 'CSS', 'JavaScript', 'React'],
  },
  {
    name: 'Playing With Numbers',
    image: 'https://64.media.tumblr.com/1cf77af67fa98c412dfecd90e1c1a8fc/2c6142eb67a1ac09-d6/s400x600/3b779c61faaf0445c1f5bd15d233499328acff0a.pnj',
    repository: 'https://github.com/tainnaps/playing-with-numbers',
    description: 'Mobile application for children to learn Math in a ludic way.',
    technologies: ['Express', 'MySQL', 'Docker', 'Sequelize', 'React Native', 'Node', 'JavaScript'],
  },
  {
    name: 'Trybe Smith',
    image: 'https://64.media.tumblr.com/61749e7be0b5692d663fd24fca3e10dc/82317a6cd3422b07-9e/s2048x3072/0c244d8c433c4409b347f28ecdd5a5c8cba22de7.pnj',
    repository: 'https://github.com/tainnaps/trybe-smith',
    description: 'API to create, read, update and delete itens of a medieval store.',
    technologies: ['Express', 'Node', 'TypeScript', 'MySQL'],
  },
  {
    name: 'Talker Manager',
    image: 'https://64.media.tumblr.com/d4e38cb69a566de5d2c8c293be242736/82317a6cd3422b07-a0/s2048x3072/9d071eee7c1f30f210a7d0ae455997c6a318f76d.jpg',
    repository: 'https://github.com/tainnaps/talker-manager',
    description: 'API to create, read, update and delete speakers of an event.',
    technologies: ['Express', 'Node', 'JavaScript'],
  },
  {
    name: 'Kawaii Trunfo',
    image: 'https://64.media.tumblr.com/7cf05fb611da3b0247e1cb61514fff6e/a668aada89668726-cb/s2048x3072/2723ae6b72e1b7f474a04ca911c52eaed062b222.pnj',
    application: 'https://tainnaps.github.io/kawaii-trunfo/',
    repository: 'https://github.com/tainnaps/kawaii-trunfo',
    description: 'Web page where you can create cute cards or delete them.',
    technologies: ['HTML', 'CSS', 'JavaScript', 'React'],
  },
  {
    name: 'Store Manager',
    image: 'https://64.media.tumblr.com/7c71d5044d3505e696c83fd62fe2a85c/82317a6cd3422b07-ca/s2048x3072/bd33771f9b7b13ed9cc2809a5d05d77aa5d6f595.pnj',
    repository: 'https://github.com/tainnaps/store-manager',
    description: 'API to create, read, update and delete products and sales.',
    technologies: ['Express', 'Node', 'JavaScript', 'MySQL', 'Mocha/Chai', 'Sinon'],
  },
  {
    name: 'One For All',
    image: 'https://64.media.tumblr.com/f110794d1b0c32636ffaa952cf5846ca/d5d0d3281b708a05-4f/s1280x1920/5e58d73478599b7d369db62daab775aad969a4b6.pnj',
    repository: 'https://github.com/tainnaps/one-for-all',
    description: 'Project developed to model and consult a SQL database.',
    technologies: ['MySQL'],
  },
  {
    name: 'Blogs API',
    image: 'https://64.media.tumblr.com/c64ae15d38e910b4d2bf3bfed91dab4a/82317a6cd3422b07-6a/s2048x3072/c20e5c6af1eb14e0d95646e8d01804ef574b32b7.pnj',
    repository: 'https://github.com/tainnaps/blogs-api',
    description: 'API to create, read, update and delete users and blog posts.',
    technologies: ['Express', 'Node', 'JavaScript', 'MySQL', 'Docker', 'Sequelize'],
  },
  {
    name: 'All For One',
    image: 'https://64.media.tumblr.com/2d8d28b9bc74ed3cf7ea2510cce95964/82317a6cd3422b07-c6/s2048x3072/afbd49e3aa17af702a4be3218dcc00b760e2a21f.pnj',
    repository: 'https://github.com/tainnaps/all-for-one',
    description: 'Project developed to manipulate data throught SQL queries.',
    technologies: ['MySQL'],
  },
  {
    name: 'To Do List',
    image: 'https://64.media.tumblr.com/0e429f0f5d975d9e7a096573fd6268a7/19614456a0d6112e-a1/s2048x3072/cc29eece4db8b6341fe8e056f3479de40ee5f6f0.pnj',
    application: 'https://tainnaps.github.io/to-do-list/',
    repository: 'https://github.com/tainnaps/to-do-list',
    description: 'Web application to add, mark as completed, save and delete tasks.',
    technologies: ['HTML', 'CSS', 'JavaScript'],
  },
];

export default projects;
